var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "p-2 flex-shrink-0 bg-gray-300 mb-1" },
        [
          _c("note-viewer", {
            attrs: { note: _vm.note, "store-note-url": _vm.storeNoteUrl },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("chat", {
        staticClass: "flex-grow-1",
        attrs: {
          "index-url": _vm.indexUrl,
          "store-url": _vm.storeUrl,
          conversation: _vm.conversation,
          "index-media-url": _vm.indexMediaUrl,
          "can-create-media": _vm.canCreateMedia,
          "store-media-url": _vm.storeMediaUrl,
          "can-send-message": _vm.canSendMessage,
          types: _vm.types,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }